/**
 * Shared component strings.
 *
 * Namespace: components
 */
export const components = {
  // Error boundary
  errorBoundary: {
    title: "Hiba történt",
    message: "Sajnáljuk, váratlan hiba lépett fel. Kérjük, próbálja újra.",
    technicalDetails: "Technikai részletek",
    retryButton: "Próbálja újra",
  },

  // Accessibility
  accessibility: {
    loading: "Betöltés...",
    required: "kötelező",
    closeButton: "Bezárás",
    dismissAlert: "Értesítés elvetése",
    showPassword: "Jelszó megjelenítése",
    hidePassword: "Jelszó elrejtése",
  },

  // Input affordances
  input: {
    capsLockOn: "A Caps Lock be van kapcsolva.",
  },

  // Password strength indicator
  passwordStrength: {
    weak: "Gyenge",
    medium: "Közepes",
    strong: "Erős",
    veryStrong: "Nagyon erős",
  },
} as const;
